$step-background-color--last-checked: #fff;

$checked-load-duration: 0.3s;

*,
::before,
::after {
  box-sizing: border-box;
}

:where(.title, .description) {
  font: unset;
  margin: 0;
  padding: 0;
  text-align: start;
}

:host {
  /**
   * @prop --last-checked-gradient:
   * Define the gradient background that the last checked step will animate.
   */
  --last-checked-gradient: linear-gradient(
    90deg,
    #00000000,
    #{$step-background-color--last-checked},
    #00000000
  );

  /**
   * @prop --step-background-color:
   * Define the gradient background color of the steps.
   */
  --step-background-color: #ddd;

  /**
   * @prop --step-background-color:
   * Define the gradient background color of the steps when checked.
   */
  --step-background-color--checked: #bbb;

  display: block;
  width: 100%;
}

.steps-container {
  display: flex;
  column-gap: 4px;
  height: 8px;
}

// - - - - - - - - - - - - - - - -
//              Steps
// - - - - - - - - - - - - - - - -
.step {
  position: relative;
  background-color: var(--step-background-color);
  border-radius: 20px;
  width: 68px;
  max-width: calc(100% / var(--amount-of-steps));
  height: 100%;
  overflow: hidden;

  &--checked::before {
    content: "";
    display: flex;
    position: absolute;
    width: 0;
    height: 100%;
    background-color: var(--step-background-color--checked);
    animation: checked-load $checked-load-duration linear
      calc(var(--delay) * #{$checked-load-duration}) forwards;
  }

  &--last-checked::after {
    content: "";
    display: flex;
    position: absolute;
    background: var(--last-checked-gradient), var(--last-checked-gradient);
    width: 80%;
    height: 100%;
    margin-inline-start: -128%;
    animation: last-checked-animation 2.25s ease-in-out
      calc(var(--delay) * #{$checked-load-duration}) infinite;
  }
}

// - - - - - - - - - - - - - - - -
//           Description
// - - - - - - - - - - - - - - - -
.description {
  transition: opacity 300ms linear;
}

.description-transition {
  opacity: 0;
}

// - - - - - - - - - - - - - - - -
//           Key frames
// - - - - - - - - - - - - - - - -
@keyframes checked-load {
  to {
    width: 100%;
  }
}

@keyframes last-checked-animation {
  to {
    margin-inline-start: 192%;
  }
}
